const theme = {
    light: {
        colors: {
            primary: "#000000",
            secondary: "#cdd40a",
            tertiary: "#CCCCCC",
            background: "#f0f0f0",
            cardBackground: "#fff",
            disabledBackground: "#888888",
            headerBackground: "#fff",
            footerBackground: "#fff",
            modalBackground: "#eee",
            label: {
                text: "#333",
                active: "#000",
                disabled: "#ccc",
            },
            link: "#cdd40a",
            text: "#000",
            disabledText: "#ccc",
            highlightedText: "#cdd40a",
            invertedText: "#FFF",
            invertedDisabledText: "#333",
            buttonText: "#fff",
            buttonHighlight: "#cdd40a",
            cancelButtonText: "#fff",
            invertedButtonText: "#000",
            input: {
                background: "#fff",
                border: "lightgray",
                disabledText: "#ccc",
                highlightedOption: "#aaa",
                invalid: "#ff0000",
                text: "#000",
            },
            scrollbarThumb: "#333",
            scrollbarBackground: "#eee",
            sideBar: {
                activeOption: "#cdd40a",
                background: "#fff",
                border: "#f0f0f0",
                invertedBorder: "#ccc",
                completedOption: "#fff",
                text: "#000",
                unavailableOption: "#fff",
                unavailableText: "#ccc"
            },
        },
        fonts: {
            base: "'Trebuchet MS', sans-serif",
            size: "12px",
        },
    },
    dark: {
        colors: {
            primary: "#cdd40a",
            secondary: "#000000",
            tertiary: "#666666",
            background: "#121212",
            cardBackground: "#1E1E1E",
            disabledBackground: "#2C2C2C",
            headerBackground: "#1E1E1E",
            footerBackground: "#1E1E1E",
            modalBackground: "#2C2C2C",
            label: {
                text: "#B0B0B0",
                active: "#FFFFFF",
                disabled: "#666666",
            },
            link: "#cdd40a",
            text: "#FFFFFF",
            disabledText: "#666666",
            highlightedText: "#cdd40a",
            invertedText: "#000000",
            invertedDisabledText: "#B0B0B0",
            buttonText: "#000000",
            buttonHighlight: "#FFFFFF",
            cancelButtonText: "#FFFFFF",
            invertedButtonText: "#FFFFFF",
            input: {
                background: "#2C2C2C",
                border: "#666666",
                disabledText: "#666666",
                highlightedOption: "#000000",
                invalid: "#CF6679",
                text: "#FFFFFF",
            },
            scrollbarThumb: "#eee",
            scrollbarBackground: "#333",
            sideBar: {
                activeOption: "#000000",
                background: "#1E1E1E",
                border: "#121212",
                invertedBorder: "#555",
                completedOption: "#1E1E1E",
                text: "#FFFFFF",
                unavailableOption: "#1E1E1E",
                unavailableText: "#666666"
            },
        },
        fonts: {
            base: "'Trebuchet MS', sans-serif",
            size: "12px",
        },
    },
};

export default theme;